<template>
  <Card class="quick-quote-line-item-summary-card">
    <template #content>
      <div class="grid">
        <div
          class="col flex flex-column justify-content-evenly align-items-center"
        >
          <KeyValuePair
            :label="
              t('common.totalParam', {
                param: t('lineItems.handlingUnits', totalHandlingUnits),
              })
            "
            :value="n(totalHandlingUnits, 'basic')"
            juicy
          />
        </div>
        <div
          class="col flex flex-column justify-content-evenly align-items-center"
        >
          <KeyValuePair
            :label="
              t('common.totalParam', {
                param: t('lineItems.weight', totalWeight),
              })
            "
            :value="
              translateNumberedEntity(
                totalWeight,
                'uoms.weight.abbreviations.POUND',
              )
            "
            juicy
          />
        </div>
        <div
          class="col flex flex-column justify-content-evenly align-items-center"
        >
          <KeyValuePair
            :label="t('common.units.linearFeet', maxLength)"
            :value="
              translateNumberedEntity(
                maxLength,
                'uoms.length.abbreviations.FOOT',
              )
            "
            juicy
          />
        </div>
        <div
          class="col flex flex-column justify-content-evenly align-items-center"
        >
          <KeyValuePair
            :label="t('common.units.cubicFeet', totalVolume)"
            :value="
              translateNumberedEntity(
                totalVolume,
                'uoms.volume.abbreviations.CUBIC_FOOT',
              )
            "
            juicy
          />
        </div>
      </div>
    </template>
  </Card>
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { translateNumberedEntity } from '@rygen/rygen-ui/i18n';

import { useLineItemsSummary } from '@/composables';
import { LineItem } from '@/model';

import KeyValuePair from '@rygen/rygen-ui/components/ui/KeyValuePair.vue';
import Card from 'primevue/card';

const props = defineProps({
  lineItems: {
    type: Array as PropType<LineItem[]>,
    required: true,
  },
});
const { lineItems } = toRefs(props);

const { totalHandlingUnits, maxLength, totalVolume, totalWeight } =
  useLineItemsSummary(lineItems);
const { n, t } = useI18n();
</script>

<style>
.quick-quote-line-item-summary-card.p-card {
  .p-card-body {
    padding: 0;

    .p-card-content {
      padding: 0;

      .grid {
        .col {
          padding: var(--p-card-body-padding);

          &:not(:last-of-type) {
            border-right: var(--divider);
          }

          .key-value-pair {
            .key-value-pair-label {
              text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>
